import React from "react";
import styled from "styled-components";
import { makeStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    color: "white",
    fontSize: "12px !important",
    backgroundColor: "#5A5A5A",
    borderRadius: 3,
    fontFamily: "Roboto",
    padding: "8px 10px",
    fontWeight: 500,
  },
}));

const ButtonIcon = styled(IconButton)`
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  transition: all 0.35s;
  padding: 0;
  height: ${(props) => props.pixel + "px"};
  width: ${(props) => props.pixel + "px"};
  min-width: ${(props) => props.pixel + "px"};
  min-height: ${(props) => props.pixel + "px"};
  ${(props) => (props.position ? "position: absolute !important;" : "")}
  right: ${(props) => (props.right ? props.right + "px" : "")};
  left: ${(props) => (props.left ? props.left + "px" : "")};
  top: ${(props) => (props.top ? props.top + "px" : "")};
  opacity:${(props) => (props.opacity ? "0.5" : "1")};
  bottom: ${(props) => (props.bottom ? props.bottom + "px" : "")};
  ${(props) => props.bluebg ? "color: #E5E5E5 !important;" : "color: #A0A0A0 !important;"}
  ${(props) => (props.bluebg ? "background-color: #487BF2 !important;" : props.toggle ? "background-color:  rgba(255, 255, 255, 0.1) !important;" : "background-color: #A0A0A0;")}
  

  &.MuiIconButton-root:focus {
    outline: none;
  }

  .MuiIconButton-label {
    width: auto;
  }

  svg {
    pointer-events: none;
    font-size: ${({ theme }) => theme.font.size.icon};
    ${(props) => (props.bluebg ? "fill: #E5E5E5" : props.toggle ? "fill:#FFFFFF" : "fill: #A0A0A0")};
    transition: all 0.35s;
  }

  &:hover {
    ${(props) =>
    props.bluebg
      ? "background-color: rgba(72, 123, 242, 0.9) !important;"
      : "background-color: rgba(255, 255, 255, 0.1) !important;"}
    color: white !important;

    svg {
      fill: white;
    }
  }

  .iconStraighten {
    transform: rotate(-45deg);
  }

  &:disabled,
  &[disabled] {
      color: #4a4a4a !important;

      svg {
        fill: #4a4a4a !important;
      }
  }
`;

const TooltipIconButton = React.forwardRef(
  (
    {
      props,
      disabled,
      children,
      title,
      placement,
      ariaLabel,
      onClick,
      size,
      position,
      top,
      right,
      left,
      bottom,
      bluebg,
      opacity,
      onMouseLeave,
      toggle,
      border
    },
    ref
  ) => {
    const classes = useStyles();
    return (
      <Tooltip
        classes={classes}
        {...props}
        title={title}
        placement={placement}
        aria-label={ariaLabel}
        ref={ref}>
        <span>
          <ButtonIcon
            onClick={onClick}
            disabled={disabled}
            aria-label={ariaLabel}
            pixel={size}
            position={position}
            top={top}
            right={right}
            left={left}
            bottom={bottom}
            bluebg={bluebg}
            opacity={opacity}
            onMouseLeave={onMouseLeave}
            toggle={toggle}
            style={{ border: border ? '1px dashed #C4C4C4' : null }}>
            {children}
          </ButtonIcon>
        </span>
      </Tooltip>
    );
  }
);

export default TooltipIconButton;
